<template>
    <v-card class="kim-card pa-2">
        <v-card-text>

            <diagnosis-picker
                    v-if="!readonly"
                    label="Buscar/crear diagnóstico"
                    :event-id="eventId"
                    @change="onDiagnosisSelect"
            />

            <template v-if="diagnoses.length === 0">
                <v-card-text class="text-center">
                    <h1 class="caption">No se ha agregado un diagnóstico</h1>
                </v-card-text>
            </template>

            <template v-else>
                <v-card-text class="py-1" >


                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th scope="col" width="40px" class="text-left"></th>
                        <th scope="col" class="text-left">Descripción</th>
                        <th scope="col" class="text-center">Eliminar</th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr
                            v-for="(item, i) in diagnoses"
                            :key="item.id">
                          <td>{{i+1}}</td>
                          <td class="text-left">{{item.name}}</td>
                          <td class="text-center">
                            <v-btn icon ripple v-if="!readonly">
                              <v-icon color="accent" @click="deleteDiagnosis(item)">delete</v-icon>
                            </v-btn>
                          </td>

                        </tr>

                      </tbody>
                    </template>
                  </v-simple-table>

                </v-card-text>

            </template>

        </v-card-text>


        <kimsa-confirm
                ref="deleteModal"
                title="Eliminar diagnóstico"
                content="¿Está seguro que desea eliminar este ítem?"
                :loading="loadingDelete"
                :persistent="false"
                @confirm="deleteConfirm"
                :close-on-confirm="false"
        ></kimsa-confirm>

    </v-card>
</template>

<script>

    import DiagnosisPicker from './DiagnosisPicker'
    import KimsaConfirm from '@/components/common/KimsaConfirm'

    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapState, mapMutations} from 'vuex'

    export default{
        props: ['readonly', 'eventId', 'clientDiagnoses'],
        components: {
            DiagnosisPicker,
            KimsaConfirm
        },
        data(vm){
            return {
                loadingAttach: false,
                loadingDelete: false,
                diagnoses: vm.clientDiagnoses || [],
                diagnosisToDetach: null
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            async onDiagnosisSelect(diagnosis){

                var vm = this
                if (!diagnosis) return

                vm.loadingAttach = true
                const response = await ApiUtils.makePost(`diagnosis/attach`, {
                    schedule_event_id: vm.eventId,
                    diagnosis_id: diagnosis.id
                })
                vm.loadingAttach = false

                if (response.ok) {
                    const json = await response.json()
                    const attachedItem = json.result.diagnosis
                    vm.$emit('attach', attachedItem)
                }
            },
            deleteDiagnosis(diagnosis){
                var vm = this
                vm.diagnosisToDetach = diagnosis
                vm.$refs.deleteModal.show()
            },
            async deleteConfirm(){
                var vm = this

                if(vm.loadingDelete || !vm.currentProvider) return

                if(!vm.diagnosisToDetach) {
                    throw new Error('Item to delete not set')
                }

                vm.loadingDelete = true
                const response = await ApiUtils.makePost(`diagnosis/detach`, {
                    diagnosis_id: vm.diagnosisToDetach.id,
                    schedule_event_id: vm.eventId,
                })
                vm.loadingDelete = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando eliminar el item')
                    return
                }

                vm.$emit('detach', {
                    id: vm.diagnosisToDetach.id
                })

                vm.diagnosisToDetach = null
                vm.$refs.deleteModal.hide()
            },
        },
        computed: {
            ...mapState(['currentProvider'])
        },
        watch: {
            clientDiagnoses(val){
                this.diagnoses = val
            }
        }
    }
</script>
